/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Create_NamedInputs */

const en_create_named = /** @type {(inputs: Create_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Create "${i?.name}"`)
};

const nl_create_named = /** @type {(inputs: Create_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" aanmaken`)
};

/**
* | output |
* | --- |
* | "Create \"{name}\"" |
*
* @param {Create_NamedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const create_named = /** @type {((inputs: Create_NamedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_NamedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_create_named(inputs)
	return en_create_named(inputs)
});